import { Container, Card, CardHeader, CardFooter, CardTitle } from "reactstrap"

const Void = () => (
    <Container className="my-5" style={{maxWidth: 600}}>
        <Card>
            <CardHeader>
                <CardTitle className="mb-0"><i className="fas fa-info-circle text-warning " /> Document Voided</CardTitle>
            </CardHeader>

            <CardFooter>
                <p className="mb-0">This document has been voided and can longer be signed.</p>
            </CardFooter>
            
        </Card>
    </Container>
)

export default Void;